<template>
  <div class="ui-components">
    <h3>buttons</h3>
    <p>
      <ui-button>Edit</ui-button>
      <ui-button iconName="icon--pencil">Edit</ui-button>
      <ui-button iconName="icon--plus-white" :primary="true">Edit</ui-button>
      <ui-button iconName="icon--search" :hideLabel="true" :circle="true">Search</ui-button>
    </p>
    <p>
      <ui-button size="small">Edit</ui-button>
      <ui-button size="small" iconName="icon--pencil">Edit</ui-button>
      <ui-button size="small" iconName="icon--plus-white" :primary="true">Edit</ui-button>
    </p>
    <h3>switch</h3>
    <p>
      <ui-switch v-model="isOn"/>
      <ui-switch :on="isOn2" @click="isOn2 = $event"/>
    </p>
    <h3>selectbox</h3>
    <p>
      <timezone-selectbox value="Asia/Seoul" :width="340"
        @change="onTimezoneChange"/>
    </p>
    <h3>tooltip</h3>
    <p class="tooltip-component">
      <ui-icon-tooltip>some tooltip content</ui-icon-tooltip>
      <ui-icon-tooltip iconSize="normal">some tooltip content</ui-icon-tooltip>
      <ui-icon-tooltip arrowCenter iconSize="normal" style="margin-left: 100px;">some tooltip content</ui-icon-tooltip>
      <ui-icon-tooltip arrowRight>some tooltip content</ui-icon-tooltip>
    </p>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import UiSwitch from '@/components/ui/UiSwitch'
import TimezoneSelectbox from '@/components/ui/TimezoneSelectbox'
import UiIconTooltip from '@/components/ui/UiIconTooltip'

export default {
  name: 'UiComponents',
  components: {
    UiButton,
    UiSwitch,
    TimezoneSelectbox,
    UiIconTooltip
  },
  data () {
    return {
      isOn: false,
      isOn2: true
    }
  },
  methods: {
    onTimezoneChange (value) {
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-components {
  p,
  h3 {
    margin: 10px;
  }
  h3 {
    font-size: 15px;
    color: #000;
  }
  button {
    margin-right: 6px;
  }
  .tooltip-component {
    margin-left: 20px;
    .tooltip {
      margin-right: 8px;
    }
  }
}
</style>
